import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import ContactPage from './pages/ContactPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import DocsPage from './pages/DocsPage'
import PlaygroundPage from './pages/PlaygroundPage'
import MATRIZDashboard from './pages/MATRIZDashboard'
import AutomationDashboard from './pages/AutomationDashboard'
import APIReferencePage from './pages/APIReferencePage'
import ChatPage from './pages/ChatPage'
import CLIToolsPage from './pages/CLIToolsPage'
import ProductsPage from './pages/ProductsPage'
import EditorPage from './pages/EditorPage'
import TerminalPage from './pages/TerminalPage'
import CommunityPage from './pages/CommunityPage'
import JournalPage from './pages/JournalPage'
import ConstellationCLIPage from './pages/ConstellationCLIPage'

function App() {
  return (
    <div className="min-h-screen bg-consciousness-deep text-awareness-silver">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dashboard" element={<MATRIZDashboard />} />
        <Route path="/automation" element={<AutomationDashboard />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/api-reference" element={<APIReferencePage />} />
        <Route path="/playground" element={<PlaygroundPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/cli-tools" element={<CLIToolsPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/terminal" element={<TerminalPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/constellation" element={<ConstellationCLIPage />} />
      </Routes>
    </div>
  )
}

export default App
